/* HK product page (hk-main-product section): gallery, thumbnails, lightbox, variant re-render and
   buy-now quantity sync. One instance per [data-hk-pdp-uid] root; a theme-editor re-render tears the
   previous instance down (window.__hkPdp[uid].destroy) and starts a new one. */
(function () {
  'use strict';

  function init(uid) {
    var root = document.getElementById('hk-root-' + uid);
    if (!root) return;

    /* Theme-editor safety: when the section re-renders, tear down the previous
       instance's listeners/subscriptions instead of stacking duplicates. */
    window.__hkPdp = window.__hkPdp || {};
    if (window.__hkPdp[uid]) window.__hkPdp[uid].destroy();
    var ac = new AbortController();
    var on = function (el, type, fn, opts) {
      if (!el) return;
      var o = opts || {};
      o.signal = ac.signal;
      el.addEventListener(type, fn, o);
    };
    var unsubscribers = [];
    window.__hkPdp[uid] = {
      destroy: function () {
        ac.abort();
        unsubscribers.forEach(function (u) { try { u(); } catch (e) {} });
      }
    };

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var finePointer  = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var zoomEnabled  = root.classList.contains('hk-pdp--zoom');

    /* ══ Gallery ══════════════════════════════════════════════════════════ */
    var mediaWrap = document.getElementById('hk-media-wrap-' + uid);
    var mainImg   = document.getElementById('hk-main-img-' + uid);
    var counter   = document.getElementById('hk-counter-' + uid);
    var strip     = document.getElementById('hk-thumbs-' + uid);
    var thumbs    = strip ? Array.prototype.slice.call(strip.querySelectorAll('[data-hk-thumb]')) : [];
    var total     = thumbs.length;
    var current   = Math.max(0, thumbs.findIndex(function (t) { return t.classList.contains('is-active'); }));

    var lightbox  = document.getElementById('hk-lightbox-' + uid);
    var lbImg     = document.getElementById('hk-lb-img-' + uid);
    var lbCounter = document.getElementById('hk-lb-counter-' + uid);
    var lastFocus = null;
    var fadeTimer = null;

    function setZoom(onState) {
      if (mediaWrap) mediaWrap.classList.toggle('is-zoomed', !!onState);
    }

    function goTo(idx, opts) {
      opts = opts || {};
      if (!total) return;
      idx = ((idx % total) + total) % total;
      current = idx;
      var t = thumbs[idx];
      setZoom(false);

      if (mainImg) {
        var apply = function () {
          mainImg.srcset = t.dataset.srcset || '';
          mainImg.src = t.dataset.src;
          mainImg.alt = t.dataset.alt || '';
        };
        if (opts.instant || reduceMotion) {
          apply();
        } else {
          clearTimeout(fadeTimer);
          mainImg.classList.add('is-fading');
          fadeTimer = setTimeout(function () {
            apply();
            var done = function () { mainImg.classList.remove('is-fading'); };
            if (mainImg.complete) done(); else mainImg.addEventListener('load', done, { once: true });
            mainImg.addEventListener('error', done, { once: true });
          }, 160);
        }
      }

      thumbs.forEach(function (el, i) {
        var active = i === idx;
        el.classList.toggle('is-active', active);
        if (active) el.setAttribute('aria-current', 'true'); else el.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = (idx + 1) + ' / ' + total;

      /* scroll the strip only — scrollIntoView would also scroll the page */
      if (strip && t) {
        var sr = strip.getBoundingClientRect();
        var tr = t.getBoundingClientRect();
        var delta = (tr.left + tr.width / 2) - (sr.left + sr.width / 2);
        if (Math.abs(delta) > 1) strip.scrollBy({ left: delta, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      if (lightbox && !lightbox.hidden) renderLightbox();
      updateExpand();
    }

    thumbs.forEach(function (t, i) { on(t, 'click', function () { goTo(i); }); });
    on(root.querySelector('#hk-media-wrap-' + uid + ' [data-hk-prev]'), 'click', function (e) { e.stopPropagation(); goTo(current - 1); });
    on(root.querySelector('#hk-media-wrap-' + uid + ' [data-hk-next]'), 'click', function (e) { e.stopPropagation(); goTo(current + 1); });

    /* Keyboard: arrows work while focus is anywhere inside the gallery */
    var mediaCol = root.querySelector('.hk-pdp__media');
    on(mediaCol, 'keydown', function (e) {
      if (!total || (lightbox && !lightbox.hidden)) return;
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'Enter' && e.target === mediaWrap && zoomEnabled) { e.preventDefault(); openLightbox(); }
    });

    /* Swipe */
    if (mediaWrap && total > 1) {
      var sx = 0, sy = 0;
      on(mediaWrap, 'touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      on(mediaWrap, 'touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) goTo(dx < 0 ? current + 1 : current - 1);
      }, { passive: true });
    }

    /* Zoom: desktop = click to zoom, cursor pans; touch = tap opens lightbox */
    if (mediaWrap && zoomEnabled && mainImg) {
      var setOrigin = function (e) {
        var r = mediaWrap.getBoundingClientRect();
        mediaWrap.style.setProperty('--zoom-x', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        mediaWrap.style.setProperty('--zoom-y', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      };
      on(mediaWrap, 'click', function (e) {
        if (e.target.closest('button')) return;
        if (!finePointer) { openLightbox(); return; }
        setOrigin(e);
        setZoom(!mediaWrap.classList.contains('is-zoomed'));
      });
      on(mediaWrap, 'mousemove', function (e) { if (mediaWrap.classList.contains('is-zoomed')) setOrigin(e); });
      on(mediaWrap, 'mouseleave', function () { setZoom(false); });
    }

    /* Thumb-strip arrows (shown only when the strip overflows) */
    var taPrev = document.getElementById('hk-ta-prev-' + uid);
    var taNext = document.getElementById('hk-ta-next-' + uid);
    if (strip && taPrev && taNext) {
      var updateArrows = function () {
        taPrev.hidden = strip.scrollLeft <= 2;
        taNext.hidden = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
      };
      on(taPrev, 'click', function () { strip.scrollBy({ left: -strip.clientWidth * 0.8, behavior: 'smooth' }); });
      on(taNext, 'click', function () { strip.scrollBy({ left:  strip.clientWidth * 0.8, behavior: 'smooth' }); });
      on(strip, 'scroll', updateArrows, { passive: true });
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(updateArrows);
        ro.observe(strip);
        unsubscribers.push(function () { ro.disconnect(); });
      }
      updateArrows();
    }

    /* ══ Lightbox (focus-managed dialog) ═════════════════════════════════ */
    /* UX-044: "expand" only when the photo has more pixels than the page already shows (600 px masters don't) */
    var expandBtn = root.querySelector('#hk-media-wrap-' + uid + ' [data-hk-expand]');
    function updateExpand() {
      if (!expandBtn || !mainImg) return;
      var src = thumbs[current] || mainImg;
      var w = parseInt(src.dataset.w, 10);
      expandBtn.hidden = !!w && w <= mainImg.getBoundingClientRect().width;
    }

    function renderLightbox() {
      if (!lbImg) return;
      var t = thumbs[current];
      lbImg.src = t ? t.dataset.full : (mainImg ? (mainImg.dataset.full || mainImg.currentSrc || mainImg.src) : '');
      lbImg.alt = t ? (t.dataset.alt || '') : (mainImg ? mainImg.alt : '');
      if (lbCounter && total) lbCounter.textContent = (current + 1) + ' / ' + total;
    }
    function openLightbox() {
      if (!lightbox) return;
      lastFocus = document.activeElement;
      setZoom(false);
      renderLightbox();
      lightbox.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = lightbox.querySelector('[data-hk-lb-close]');
      if (closeBtn) closeBtn.focus();
    }
    function closeLightbox() {
      if (!lightbox || lightbox.hidden) return;
      lightbox.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    on(root.querySelector('#hk-media-wrap-' + uid + ' [data-hk-expand]'), 'click', function (e) { e.stopPropagation(); openLightbox(); });
    if (mainImg) {
      on(mainImg, 'load', updateExpand);
      if ('ResizeObserver' in window) {
        var expandRo = new ResizeObserver(updateExpand);
        expandRo.observe(mainImg);
        unsubscribers.push(function () { expandRo.disconnect(); });
      }
    }
    updateExpand();
    if (lightbox) {
      on(lightbox.querySelector('[data-hk-lb-close]'), 'click', closeLightbox);
      on(lightbox.querySelector('[data-hk-lb-prev]'), 'click', function () { goTo(current - 1, { instant: true }); });
      on(lightbox.querySelector('[data-hk-lb-next]'), 'click', function () { goTo(current + 1, { instant: true }); });
      /* the photo box fills the screen (object-fit: contain), so "outside the photo" is the letterbox around the
         painted image, not only the backdrop */
      var outsidePhoto = function (e) {
        if (e.target === lightbox) return true;
        if (e.target !== lbImg || !lbImg.naturalWidth) return false;
        var r = lbImg.getBoundingClientRect();
        var scale = Math.min(r.width / lbImg.naturalWidth, r.height / lbImg.naturalHeight);
        var w = lbImg.naturalWidth * scale, h = lbImg.naturalHeight * scale;
        var x = r.left + (r.width - w) / 2, y = r.top + (r.height - h) / 2;
        return e.clientX < x || e.clientX > x + w || e.clientY < y || e.clientY > y + h;
      };
      on(lightbox, 'click', function (e) { if (outsidePhoto(e)) closeLightbox(); });
      on(lightbox, 'keydown', function (e) {
        if (e.key === 'Escape')     { e.preventDefault(); closeLightbox(); return; }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(current - 1, { instant: true }); return; }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1, { instant: true }); return; }
        if (e.key === 'Tab') {
          var f = Array.prototype.slice.call(lightbox.querySelectorAll('button'));
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
      var lx = 0;
      on(lightbox, 'touchstart', function (e) { lx = e.touches[0].clientX; }, { passive: true });
      on(lightbox, 'touchend', function (e) {
        var dx = e.changedTouches[0].clientX - lx;
        if (Math.abs(dx) > 50 && total > 1) goTo(dx < 0 ? current + 1 : current - 1, { instant: true });
      }, { passive: true });
    }

    /* ══ Variant change (published by Dawn's product-info.js) ════════════ */
    function runScripts(container) {
      /* innerHTML never executes script tags; re-create them so custom_liquid /
         buy-buttons scripts behave the same after a refresh as on first load */
      container.querySelectorAll('script').forEach(function (old) {
        if (old.type && old.type !== 'text/javascript' && old.type !== 'module') return;
        var s = document.createElement('script');
        Array.prototype.forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
        s.textContent = old.textContent;
        old.replaceWith(s);
      });
    }

    function onVariantChange(evt) {
      var data = evt && evt.data;
      if (!data || data.sectionId !== uid || !data.html) return;
      var html = data.html;

      /* 1. gallery → variant's featured image */
      var mid = data.variant && data.variant.featured_media && data.variant.featured_media.id;
      if (mid) {
        var idx = thumbs.findIndex(function (t) { return String(t.dataset.mediaId) === String(mid); });
        if (idx >= 0 && idx !== current) goTo(idx);
      }

      /* 2. stock state on the root */
      var newRoot = html.getElementById('hk-root-' + uid);
      if (newRoot) root.setAttribute('data-hk-stock', newRoot.getAttribute('data-hk-stock') || 'in');

      /* 3. custom blocks: price, custom liquid, buy buttons */
      root.querySelectorAll('[data-hk-refresh]').forEach(function (el) {
        var fresh = html.getElementById(el.id);
        if (!fresh) return;
        el.innerHTML = fresh.innerHTML;
        runScripts(el);
      });
      if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) Shopify.PaymentButton.init();
    }

    /* constants.js / pubsub.js load deferred from <head>, before this file; subscribe once the DOM
       is parsed (immediately when it already is, e.g. after an editor re-render). */
    function subscribeVariantChange() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        unsubscribers.push(subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange));
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', subscribeVariantChange, { once: true });
    else subscribeVariantChange();

    /* Mobile contact row: same click event as the quote box's call/WhatsApp buttons */
    on(root, 'click', function (e) {
      var a = e.target.closest && e.target.closest('[data-hk-pdp-action]');
      if (!a) return;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'hk_contact_click', hk_form: 'pdp_action_row', hk_channel: a.getAttribute('data-hk-pdp-action') });
      } catch (err) {}
    });

    /* Keep the custom "Buy now" form's quantity in sync with the quantity selector */
    on(root, 'change', function (e) {
      if (!e.target.matches || !e.target.matches('#Quantity-' + uid)) return;
      root.querySelectorAll('.hk-buy-now-qty').forEach(function (q) { q.value = e.target.value; });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hk-pdp-uid]').forEach(function (el) { init(el.getAttribute('data-hk-pdp-uid')); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
